import React, { createContext, useContext } from "react";
import { secondAxios } from "../../../../../../api/axios";

const ReconcileContext = createContext();

export const useReconcileContext = () => useContext(ReconcileContext);

function ReconcileContextProvider({ children }) {
  const [companyVendors, setCompanyVendors] = React.useState([]);

  React.useEffect(() => {
    const func = async () => {
      const res = await secondAxios.get("vendor");
      setCompanyVendors(res.data);
      console.log(res.data);
    };
    func();
  }, []);

  return (
    <ReconcileContext.Provider
      value={{
        companyVendors,
      }}
    >
      {children}
    </ReconcileContext.Provider>
  );
}

export { ReconcileContextProvider, ReconcileContext };
